import script from "./OrganizationListingPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrganizationListingPage.vue?vue&type=script&setup=true&lang=ts"

import "./OrganizationListingPage.vue?vue&type=style&index=0&id=3473bce6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3473bce6"]])

export default __exports__